<template>
  <main id="app-kulineran">
    <router-view />
    <Footer />
  </main>
</template>

<script>
import Footer from "./components/Footer.vue";

export default {
  components: {
    Footer,
  },
};
</script>

<style scoped>
#app-kulineran {
  font-family: "Montserrat", sans-serif !important;
}
</style>
